import { Injectable, effect, inject, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { BrandingService } from './branding.service';

/**
 * Título da aba no formato "Tela · Escritório". Telas de detalhe trocam o nome da tela pelo
 * registro aberto (processo, cliente, cobrança...) com `setRecord`.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private readonly title = inject(Title);
  private readonly branding = inject(BrandingService);

  private readonly page = signal<string | null>(null);
  private readonly record = signal<string | null>(null);

  constructor() {
    effect(() => {
      const office = this.branding.displayName();
      const label = this.record() || this.page();
      this.title.setTitle(label ? `${label} · ${office}` : office);
    });
  }

  /** Chamado pelo roteador a cada navegação; limpa o registro da tela anterior. */
  setPage(label: string | null): void {
    this.page.set(label?.trim() || null);
    this.record.set(null);
  }

  setRecord(label: string | null | undefined): void {
    this.record.set(label?.trim() || null);
  }
}
